const { createContext } = require("react");

export const LayoutContext = createContext(null);
